<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.inventories'), $t('text.list')]">
        <el-button
          v-if="shopsView.length != 0"
          type="default"
          size="mini"
          @click="exportAllData"
          >{{ $t("action.exportAll") }}</el-button
        >
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.pNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.shelf"
            :placeholder="$t('menu.shelfs')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.minQuantity"
            :placeholder="$t('inventory.minQuantity')"
            style="width: 100px"
          />
        </el-form-item>
        <el-form-item>-</el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.maxQuantity"
            :placeholder="$t('inventory.maxQuantity')"
            style="width: 100px"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.categoryName"
            :placeholder="$t('menu.categories')"
            filterable
            clearable
          >
            <el-option
              v-for="category in categories"
              :key="category.name"
              :label="category.name"
              :value="category.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="inventriesTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        :span-method="mergeMethod"
        border　
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          style="vertical-align: top"
        >
          <template v-slot="{ row }">
            <div style="vertical-align: top; margin-top: 0px">
              <div class="float-left">
                <thumbnail :images="row._images" />
              </div>
              <div class="float-left mgl5">
                {{ row._productNo }}
                <div class="font10">{{ row._categoryName }}</div>
                <div class="font10">{{ row._productBrand }}</div>
                <div
                  v-if="row.labelsJson != null && row.labelsJson != ''"
                  class="font10"
                >
                  {{ JSON.parse(row._labelsJson).join(",") }}
                </div>

                <div class="font10">
                  {{ $t("inventory.invLockQty") }}:{{ row._quantity }}/{{
                    row._totalLock
                  }}
                </div>
              </div>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          width="100"
        />
        <vxe-table-column
          field="size"
          :title="$t('product.size')"
          width="100"
        />
        <vxe-table-column
          v-if="Permit.canActions('globalSalePrice')"
          field="salesPrice"
          :title="$t('product.price')"
          width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.productPrice != null">{{
              row.productPrice | currency
            }}</span>
            <span v-else>{{ row._productPrice | currency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('inventory.quantity')"
          width="80"
        >
          <template v-slot="{ row }">{{ row.quantity }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="totalLock"
          :title="$t('inventory.totalLock')"
          width="80"
        >
          <template v-slot="{ row }">{{ row.totalLock }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="warnQuantity"
          :title="$t('inventory.warnQuantity')"
          width="80"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('menu.warehouses')"
          width="100"
        />
        <vxe-table-column field="shelf" :title="$t('menu.shelfs')" width="200">
          <template v-slot="{ row }">
            <span v-if="row.shelf != null && row.shelf != ''">{{
              JSON.parse(row.shelf).join("，")
            }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- 库存快照 -->
    <el-dialog
      :title="$t('action.exportAll')"
      :visible.sync="exportAllDataDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="exportAllDataObjForm" :model="exportAllDataObj">
        <el-form-item
          :prop="'checkedShopIds'"
          :rules="[
            {
              required: true,
              message: $t('rules.select', [$t('menu.warehouses')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-checkbox-group v-model="exportAllDataObj.checkedShopIds">
            <el-checkbox
              v-for="shop in shopsInv"
              :key="shop.id"
              :label="shop.id"
              >{{ shop.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="exportAllDataSubmitDoing"
          size="small"
          @click="exportAllDataSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="exportAllDataDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Inventory from "@/api/inventory.js";
import InventoriesSnapshoot from "@/api/inventoriesSnapshoot.js";
import StockInOut from "@/api/stockInOut.js";
import Shop from "@/api/shop.js";
import Category from "@/api/category.js";
import Brand from "@/api/brand";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      Util: Util,
      StockInOut: StockInOut,
      narrows: [
        [
          {
            label: "库存情况",
            items: [
              {
                label: ">报警数量",
                key: "yes",
                condition: { warn: "yes" },
              },
              {
                label: "<=报警数量",
                key: "no",
                condition: { warn: "no" },
              },
            ],
          },
          {
            label: "库存数量情况",
            items: [
              {
                label: "数量>0",
                key: "quantityYes",
                condition: { inStock: "yes" },
              },
              {
                label: "数量 <= 0",
                key: "quantityNo",
                condition: { inStock: "no" },
              },
            ],
          },
        ],
      ],

      // initFilter: "yes",
      searchForm: {
        pNo: null,
        shelf: null,
        minQuantity: null,
        maxQuantity: null,
        categoryName: null,
        shopId: null,
        productBrand: null,
        color: null,
        size: null,
      },
      shops: [],
      shopsInv: [],
      shopsView: [],
      shopsManage: [],
      categories: [],
      // 快照
      exportAllDataDF: false,
      exportAllDataObj: { checkedShopIds: [] },
      exportAllDataSubmitDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        snapDate: this.$route.params.snapDate,
      };
    },
  },
  created() {
    const self = this;
    axios
      .all([
        Brand.findByTenantId(),
        Shop.findByTenantId(),
        Category.findByTenantId(),
      ])
      .then(
        axios.spread(function (brands, shops, categories) {
          if (brands.status === 200) {
            if (brands.data.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("product.brand"),
                  items: brands.data.map((brand) => {
                    return {
                      label: brand.name,
                      key: brand.name,
                      condition: { brand: brand.name },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
            self.shopsInv = self.shops.filter((s) => s.isInventory == true);
            if (self.Permit.currentUser().admin) {
              self.shopsManage = self.shops;
              self.shopsView = self.shops;
            } else {
              self.shopsManage = self.shops.filter(
                (s) =>
                  self.Permit.wmsManageShopIds().includes(s.id) &&
                  s.isInventory == true
              );
              self.shopsView = self.shops.filter(
                (s) =>
                  self.Permit.wmsViewShopIds().includes(s.id) &&
                  s.isInventory == true
              );
            }
            if (self.shopsView.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("menu.warehouses"),
                  items: self.shopsView.map((shop) => {
                    return {
                      label: shop.name,
                      key: shop.id,
                      condition: { shopId: shop.id },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }

          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    // 快照
    exportAllData() {
      const self = this;
      self.exportAllDataObj.checkedShopIds = [];
      self.exportAllDataSubmitDoing = false;
      if (self.shopsView.length === 1) {
        self.exportAllDataObj.checkedShopIds = self.shopsView[0].id;
        self.exportAllDataSubmitFunction();
      } else {
        self.exportAllDataDF = true;
      }
    },
    exportAllDataSubmit() {
      const self = this;
      self.$refs.exportAllDataObjForm.validate((valid) => {
        if (valid) {
          self.exportAllDataSubmitFunction();
        } else {
          return false;
        }
      });
    },
    exportAllDataSubmitFunction() {
      const self = this;
      self.exportAllDataSubmitDoing = true;
      InventoriesSnapshoot.quickPhotoExportExcel({
        shopIds: self.exportAllDataObj.checkedShopIds,
        snapDate: self.$route.params.snapDate,
      }).then(function (res) {
        self.exportAllDataSubmitDoing = false;
        self.exportAllDataDF = false;
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //-----
    dataProvider(params) {
      return InventoriesSnapshoot.productNoSearch(params);
    },

    recordsDecorate(records) {
      this.records = this.buildTableData(records);
      this.mergeCells = this.buildMergeCells(records);
    },

    buildTableData(inventories) {
      let rs = [];
      inventories.forEach((bg) => {
        // let obj = {
        //   id: bg.id,
        //   serialNo: bg.serialNo,
        //   customerName: bg.customerName,
        //   isBargain: true,
        // };
        // rs.push(obj); //将bargain的数据转换到格式，放到数据列表
        bg.productNoAccountDetails.forEach((item) => {
          let obj = item;
          Vue.set(obj, "_productNo", bg.productNo);
          Vue.set(obj, "_quantity", bg.quantity);
          Vue.set(obj, "_images", bg.images);
          Vue.set(obj, "_categoryId", bg.categoryId);
          Vue.set(obj, "_categoryName", bg.categoryName);
          Vue.set(obj, "_customQuantity", bg.customQuantity);
          Vue.set(obj, "_productBrand", bg.productBrand);
          Vue.set(obj, "_manualLockQuantity", bg.manualLockQuantity);
          Vue.set(obj, "_productPrice", bg.productPrice);
          Vue.set(obj, "_labelsJson", bg.labelsJson);
          Vue.set(obj, "_totalLock", bg.totalLock);
          rs.push(obj);
        });
      });
      // console.log("=====buildTableData+++:", rs);
      return rs;
    },
    buildMergeCells(inventories) {
      let mcs = [];
      // console.log("===", inventories);
      for (let i = 0, rowIdx = 0; i < inventories.length; i++) {
        // console.log("++1", inventories[i]);
        mcs.push({
          row: rowIdx, //行
          col: 0,
          rowspan: inventories[i].productNoAccountDetails.length, //跨行
          colspan: 1, //跨列
        });
        // rowIdx = rowIdx + 1;
        rowIdx = rowIdx + inventories[i].productNoAccountDetails.length;
        // console.log("++2", inventories[i].productNoAccountDetails.length);
      }
      // console.log("=====buildMergeCells:", JSON.stringify(mcs));
      return mcs;
    },
  },
};
</script>
